import React from "react";
import { Sparkles } from "lucide-react";

/**
 * Petite étoile « IA » à placer à côté de chaque feature IA.
 *
 * Variants:
 *  - default  : pill avec étoile + label "IA"
 *  - icon     : just the star icon (compact, for tight UIs)
 *  - inline   : étoile + texte personnalisé, en ligne dans un titre
 *  - avatar   : geoVINUM AI portrait avatar (round) for hero-level callouts
 */
export default function AiBadge({ variant = "default", label, className = "", title, size = "sm" }) {
  if (variant === "avatar") {
    const px = size === "lg" ? 56 : size === "md" ? 40 : 28;
    return (
      <img
        src="/brand/audrey-ai.png"
        alt={title || "geoVINUM AI"}
        title={title || "geoVINUM AI"}
        width={px} height={px}
        style={{ width: px, height: px }}
        className={`inline-block rounded-full object-cover ring-2 ring-[#E5276A]/30 ${className}`}
        data-testid="ai-badge"
      />
    );
  }
  if (variant === "icon") {
    return (
      <span
        title={title || "Propulsé par l'IA"}
        className={`inline-flex items-center justify-center text-[#E5276A] ${className}`}
        data-testid="ai-badge"
      >
        <Sparkles className="w-3.5 h-3.5" />
      </span>
    );
  }
  if (variant === "inline") {
    return (
      <span
        title={title || "Propulsé par l'IA"}
        className={`inline-flex items-center gap-1 text-[#E5276A] font-bold ${className}`}
        data-testid="ai-badge"
      >
        <Sparkles className="w-3.5 h-3.5" /> {label || "IA"}
      </span>
    );
  }
  return (
    <span
      title={title || "Propulsé par l'IA"}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#FCE4ED] text-[#E5276A] text-[10px] uppercase tracking-[0.16em] font-bold ${className}`}
      data-testid="ai-badge"
    >
      <Sparkles className="w-3 h-3" /> {label || "IA"}
    </span>
  );
}
